import { render, staticRenderFns } from "./DashboardSettings.vue?vue&type=template&id=fc785784&scoped=true&"
import script from "./DashboardSettings.vue?vue&type=script&lang=js&"
export * from "./DashboardSettings.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSettings.vue?vue&type=style&index=0&id=fc785784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc785784",
  null
  
)

export default component.exports